<template>
    <div class="dashboard-body">
        <!-- <h1>{{ title }}</h1> -->
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 377.584 619.719" data-v-39e05124="">
            <defs data-v-39e05124=""></defs>
            <g id="组_43574_" data-name="组 43574" transform="translate(-697.687 -320.82)" data-v-39e05124="">
                <g id="牙" transform="translate(697.687 320.82)" data-v-39e05124="">
                    <g id="组_610" data-name="组 610" data-v-39e05124="">
                        <g id="组_608" data-name="组 608" transform="translate(0 0)" data-v-39e05124="">
                            <g id="组_550" data-name="组 550" data-v-39e05124="">
                                <g id="组_608-2" data-name="组 608" transform="translate(0 223.99)" data-v-39e05124="">
                                    <path id="路径_537" data-name="路径 537" class="cls-1" d="M0,49H377.584"
                                        transform="translate(0 40.778)" data-v-39e05124=""></path>
                                    <path id="路径_99" data-name="路径 99" class="cls-1" d="M0,180V363"
                                        transform="translate(189.407 -180)" data-v-39e05124=""></path>
                                    <path id="路径_552" data-name="路径 552" class="cls-1" d="M0,180V363"
                                        transform="translate(189.407 32.728)" data-v-39e05124=""></path>
                                </g>
                                <g id="组_613" data-name="组 613" transform="translate(189.407)" data-v-39e05124="">
                                    <path id="路径_99-2" data-name="路径 99" class="cls-1" d="M0,180V376.537"
                                        transform="translate(0 -180)" data-v-39e05124=""></path>
                                </g>
                            </g>
                        </g>
                    </g>
                    <g id="组_611" data-name="组 611" transform="translate(7.672 14.945)" data-v-39e05124="">
                        <g id="组_610-2" data-name="组 610" transform="translate(0 0)" data-v-39e05124="">
                            <g id="组_185" data-name="组 185" transform="translate(0)" data-v-39e05124="">
                                <g id="组_6" data-name="组 6" transform="translate(8.759 4.39)" data-v-39e05124="">
                                    <path id="上颌牙龈" class="cls-2"
                                        d="M1457.056,365.875c20.779,8.778,67.288,37.06,79.583,117.232,4.377,28.538-6.565,82.322,18.6,93.3s70.026-9.879,63.461-90.005c-6.453-78.764-84.25-201.963-171.782-195.378s-135.675,83.42-163.029,153.668,4.241,134.026,40.484,135.008c40.484,1.1,30.908-60.345,32.825-83.42,2.085-25.1,10.131-101.03,79.042-129.972C1439.648,364.874,1450.833,363.248,1457.056,365.875Z"
                                        transform="translate(-1273.552 -290.769)" data-v-39e05124=""></path>
                                    <g id="上颌牙龈-2" data-name="上颌牙龈" transform="translate(140.563 32.085)"
                                        data-v-39e05124="">
                                        <path id="路径_41" data-name="路径 41" class="cls-3" d="M1402,320"
                                            transform="translate(-1402 -320)" data-v-39e05124=""></path>
                                    </g>
                                    <g id="_28detailSvg" data-name="28" transform="translate(282.792 233.271)"
                                        data-v-39e05124="">
                                        <path id="路径_31" data-name="28-1" class="cls-4"
                                            d="M1539.321,537.749c13.3,1.987,17.277-4.068,21.828-10.435,4.206-5.883,6.588-12.735,4.764-20.37-2.544-10.648-22.667-9.3-30.392-7.95-5.7.994-7.132,10.987-8.548,19.874C1525.075,530.793,1528.684,536.159,1539.321,537.749Z"
                                            transform="translate(-1526.49 -498.09)" data-v-39e05124=""></path>
                                        <path id="路径_50" data-name="28-2" class="cls-3"
                                            d="M1548.976,508.2v4.39l-6.586,1.1,4.39,4.39,1.1,3.293-3.293,2.2-6.586,1.1,5.488,2.2,2.2,4.39,1.1-6.586h3.293l6.586,3.293v2.2l5.488-4.391-4.39,1.1-7.683-4.391v-5.488l7.683,1.1,3.293,3.293v-3.293l1.1-4.39-3.293,3.293h-8.781l1.1-7.683,2.2-1.1-4.391-2.2Z"
                                            transform="translate(-1528.927 -499.233)" data-v-39e05124=""></path>
                                    </g>
                                    <g id="_27detailSvg" data-name="27" transform="translate(286.481 191.976)"
                                        data-v-39e05124="">
                                        <path id="路径_32" data-name="27-1" class="cls-4"
                                            d="M1529.983,476.972c0,9.844,2.574,20.708,18.574,21.479,18.574.895,19.529-13,17.689-24.164-1.769-10.739-4.4-15.856-20.343-14.319C1527.329,461.758,1529.983,476.972,1529.983,476.972Z"
                                            transform="translate(-1529.852 -459.701)" data-v-39e05124=""></path>
                                        <path id="路径_49" data-name="27-2" class="cls-3"
                                            d="M1560.855,468s-2.2,6.64-6.586,6.64l-1.1-1.66h-8.781l-4.391-.83,6.586,2.49,2.2,2.49,3.293-.83,1.1,3.32-7.683,5.81,3.293.83v-.83l4.391-2.49,1.1,4.15,1.1,2.49,1.1-5.81h8.781s-9.879-1.66-9.879-4.15l-1.1-4.15h3.293l3.293-2.49Z"
                                            transform="translate(-1534.391 -458.889)" data-v-39e05124=""></path>
                                    </g>
                                    <g id="_26detailSvg" data-name="26" transform="translate(279.038 150.683)"
                                        data-v-39e05124="">
                                        <path id="路径_33" data-name="26-1" class="cls-4"
                                            d="M1557.327,427.911c6.666,5.714,8.571,24.76,0,32.378S1529.71,466,1525.9,455.527s-2.857-19.046,9.523-24.76S1554.26,425.282,1557.327,427.911Z"
                                            transform="translate(-1523.925 -426.131)" data-v-39e05124=""></path>
                                        <path id="路径_48" data-name="26-2" class="cls-3"
                                            d="M1555.25,443.519l-2.882-1.893-5.763-.947L1538.921,435l5.763,7.572V447.3L1537,451.091l8.645-.947,1.921,1.893v5.679l1.921-4.733s3.842,3.786,3.842,2.84-6.724-7.572-6.724-7.572l.961-4.733Z"
                                            transform="translate(-1524.64 -426.48)" data-v-39e05124=""></path>
                                    </g>
                                    <g id="_25detailSvg" data-name="25" transform="translate(266.713 115.645)"
                                        data-v-39e05124="">
                                        <path id="路径_30" data-name="25-1" class="cls-4"
                                            d="M1539.614,394.995c4.185,1.395,3.945,10.849,6.9,14.795s5.918,3.945,5.918,7.89c0,8.877-7.891,8.877-13.808,11.836s-8.877,5.918-13.808,4.932-5.918-7.891-7.891-11.836-5.918-5.918-4.932-11.836,9.863-7.891,13.808-9.863S1533.7,393.022,1539.614,394.995Z"
                                            transform="translate(-1511.842 -394.598)" data-v-39e05124=""></path>
                                        <path id="路径_47" data-name="25-2" class="cls-3"
                                            d="M1531.586,402v7.683l-2.2-1.1v4.391l-4.391,2.2h5.488l2.2,1.1v6.586l3.293,1.1-1.1-2.2h3.293l3.293,2.2V420.66h-2.2l-3.293-3.293-1.1-1.1v-6.586l3.293-3.293-4.391,1.1Z"
                                            transform="translate(-1512.862 -395.5)" data-v-39e05124=""></path>
                                    </g>
                                    <g id="_24detailSvg" data-name="24" transform="translate(249.779 85.613)"
                                        data-v-39e05124="">
                                        <path id="路径_29" data-name="24-1" class="cls-4"
                                            d="M1532.248,374.229c5.729,5.729,8.3,19.709-3.112,26.97s-18.672,8.3-28.008-3.112c-6.982-8.534-3.112-21.784,6.224-26.97S1524.987,366.967,1532.248,374.229Z"
                                            transform="translate(-1497.555 -367.875)" data-v-39e05124=""></path>
                                    </g>
                                    <g id="_23detailSvg" data-name="23" transform="translate(231.47 59.335)"
                                        data-v-39e05124="">
                                        <path id="路径_28" data-name="23-1" class="cls-4"
                                            d="M1514.235,347.02c8.063,5.039,4.031,20.157-4.031,25.2s-17.134,6.047-21.165,3.024-10.079-17.134,3.024-26.2S1514.235,347.02,1514.235,347.02Z"
                                            transform="translate(-1484.077 -344.406)" data-v-39e05124=""></path>
                                        <path id="路径_45" data-name="23-2" class="cls-3"
                                            d="M1505.074,353a14.637,14.637,0,0,0-9.878,7.683l-2.2,2.2s1.1-5.488,3.293-7.683S1505.074,353,1505.074,353Z"
                                            transform="translate(-1484.369 -344.637)" data-v-39e05124=""></path>
                                    </g>
                                    <g id="_22detailSvg" data-name="22" transform="translate(209.343 30.554)"
                                        data-v-39e05124="">
                                        <path id="路径_27" data-name="22-1" class="cls-4"
                                            d="M1476.707,317.99c4.772,1.06,22.528,8.485,23.508,17.912s-23.355,24.3-33.3,17.912C1458.1,348.157,1463.973,315.161,1476.707,317.99Z"
                                            transform="translate(-1462.703 -317.818)" data-v-39e05124=""></path>
                                        <path id="路径_44" data-name="22-2" class="cls-3"
                                            d="M1494.855,339.208s-4.594-6.586-8.039-8.781-6.586-2.889-8.039-2.2c-2.3,1.1-4.594,6.586-4.594,6.586s-1.148-7.683,2.3-8.781,9.187,0,12.633,3.293S1494.855,339.208,1494.855,339.208Z"
                                            transform="translate(-1464.251 -318.81)" data-v-39e05124=""></path>
                                    </g>
                                    <g id="_21detailSvg" data-name="21" transform="translate(172.734 16.788)"
                                        data-v-39e05124="">
                                        <path id="路径_26" data-name="21-1" class="cls-4"
                                            d="M1445.132,349.423c-15.146-2.02-14.137-25.244-13.127-32.312.451-3.161-.189-15.446,21.205-10.1,11.184,2.8,19.186,8.078,15.147,19.186C1463.663,339.106,1452.221,350.368,1445.132,349.423Z"
                                            transform="translate(-1431.5 -305.682)" data-v-39e05124=""></path>
                                        <path id="路径_43" data-name="21-2" class="cls-3"
                                            d="M1460.53,319.1s-9.681-5.082-19.668-2.514c0,0-2.271,1.846-1.556,11.443s5.026,11.643,5.026,11.643a18.245,18.245,0,0,1-6.2-9.764c-1.391-5.329-.645-14.664,1.709-15.268,9.987-2.569,17.457.955,21.824,3.536C1463.847,319.465,1460.53,319.1,1460.53,319.1Z"
                                            transform="translate(-1431.804 -304.894)" data-v-39e05124=""></path>
                                    </g>
                                    <g id="_11detailSvg" data-name="11" transform="translate(130.941 16.789)"
                                        data-v-39e05124="">
                                        <path id="路径_25" data-name="11-1" class="cls-4"
                                            d="M1431.036,333.778s-3.084,15.423-14.395,15.423-19.4-16.345-19.4-16.345S1381.9,311.5,1411.5,306.017C1439.261,300.876,1432.064,329.665,1431.036,333.778Z"
                                            transform="translate(-1393.269 -305.404)" data-v-39e05124=""></path>
                                        <path id="路径_42" data-name="11-2" class="cls-3"
                                            d="M1404.166,319.5s9.879-5.488,19.757-2.2c0,0,2.2,2.2,1.1,13.172s-5.488,13.172-5.488,13.172a21.167,21.167,0,0,0,6.586-10.976c1.6-6.06,1.23-16.786-1.1-17.562-9.879-3.293-17.484.486-21.953,3.293C1400.837,319.808,1404.166,319.5,1404.166,319.5Z"
                                            transform="translate(-1393.921 -306.197)" data-v-39e05124=""></path>
                                    </g>
                                    <g id="_12detailSvg" data-name="12" transform="translate(95.604 30.554)"
                                        data-v-39e05124="">
                                        <path id="路径_24" data-name="12-1" class="cls-4"
                                            d="M1373.828,321.884c10.855-4.824,19.736-6.754,23.684,13.507s-4.934,22.191-12.829,20.261-24.866-6.771-23.684-18.331C1361.986,327.673,1373.828,321.884,1373.828,321.884Z"
                                            transform="translate(-1360.94 -318.695)" data-v-39e05124=""></path>
                                        <path id="路径_40" data-name="12-2" class="cls-3"
                                            d="M1370,339.208s4.391-6.586,7.683-8.781,6.295-2.889,7.683-2.2c2.2,1.1,4.391,6.586,4.391,6.586s1.1-7.683-2.2-8.781-8.781,0-12.074,3.293S1370,339.208,1370,339.208Z"
                                            transform="translate(-1361.975 -319.368)" data-v-39e05124=""></path>
                                    </g>
                                    <g id="_13detailSvg" data-name="13" transform="translate(77.378 58.084)"
                                        data-v-39e05124="">
                                        <path id="路径_23" data-name="13-1" class="cls-4"
                                            d="M1344.919,349.134s6.35-11.769,24.883,1.028c13.4,9.251,6.7,33.922-10.527,25.7C1342.294,367.754,1341.091,354.274,1344.919,349.134Z"
                                            transform="translate(-1343.12 -344.195)" data-v-39e05124=""></path>
                                        <path id="路径_39" data-name="13-2" class="cls-3"
                                            d="M1359,353a14.639,14.639,0,0,1,9.879,7.683l2.2,2.2s-1.1-5.488-3.293-7.683S1359,353,1359,353Z"
                                            transform="translate(-1344.832 -344.186)" data-v-39e05124=""></path>
                                    </g>
                                    <g id="_14detailSvg" data-name="14" transform="translate(56.264 84.362)"
                                        data-v-39e05124="">
                                        <path id="路径_22" data-name="14-1" class="cls-4"
                                            d="M1331.045,376.368s-14.074,15.1,4.565,25.813,25.7-1.81,27.722-8.071,3.591-14.917-8.072-22.959C1346.18,364.888,1338.109,366.975,1331.045,376.368Z"
                                            transform="translate(-1325.951 -367.57)" data-v-39e05124=""></path>
                                        <path id="路径_38" data-name="14-2" class="cls-3"
                                            d="M1348.909,381.586l.927,1.1,3.709,3.293-6.49-2.2-3.709,4.391v7.683l-1.854-6.586L1335,385.976l1.854-1.1,1.854,1.1h3.709l3.709-4.391,2.782-6.586Z"
                                            transform="translate(-1325.068 -367.665)" data-v-39e05124=""></path>
                                    </g>
                                    <g id="_15detailSvg" data-name="15" transform="translate(38.845 115.645)"
                                        data-v-39e05124="">
                                        <path id="路径_21" data-name="15-1" class="cls-4"
                                            d="M1316.772,407.6s0-14.576,8.746-13.6c7.355.817,5.831,4.859,9.717,6.8s13.6,1.943,14.576,7.774c1.163,6.978-3.887,9.717-5.831,14.576s-1.943,9.718-6.8,10.689-11.661-2.915-14.576-3.887-14.576-4.859-13.6-10.689S1313.857,411.49,1316.772,407.6Z"
                                            transform="translate(-1308.941 -393.952)" data-v-39e05124=""></path>
                                        <path id="路径_37" data-name="15-2" class="cls-3"
                                            d="M1333.074,404l-1.1,4.39h4.391l-2.2,3.293,5.488,3.293h-7.683v8.781h-3.293v-4.391l-4.391,2.2-1.1,2.2-2.2-1.1,7.683-6.586,1.1-1.1-1.1-6.586-2.2-1.1h3.293l1.1-3.293Z"
                                            transform="translate(-1310.304 -395.217)" data-v-39e05124=""></path>
                                    </g>
                                    <g id="_16detailSvg" data-name="16" transform="translate(28.851 150.683)"
                                        data-v-39e05124="">
                                        <path id="路径_20" data-name="16-1" class="cls-4"
                                            d="M1322.063,431.575s19.439,1.851,12.959,20.364-25.918,12.033-25.918,12.033-12.033-4.628-11.108-23.141S1312.806,424.169,1322.063,431.575Z"
                                            transform="translate(-1297.945 -426.28)" data-v-39e05124=""></path>
                                        <path id="路径_36" data-name="16-2" class="cls-3"
                                            d="M1307,442.848l2.993-1.744,5.985-.872,7.98-5.232-5.985,6.976v4.36l7.98,3.488-8.978-.872-2,1.744v5.232l-2-4.36s-3.99,3.488-3.99,2.616,6.983-6.976,6.983-6.976l-1-4.36Z"
                                            transform="translate(-1299.169 -426.3)" data-v-39e05124=""></path>
                                    </g>
                                    <g id="_17detailSvg" data-name="17" transform="translate(20.466 191.976)"
                                        data-v-39e05124="">
                                        <path id="路径_19" data-name="17-1" class="cls-4"
                                            d="M1312.381,458.931s-20.124-5.234-21.389,18.431c-1.337,25.013,18.715,19.309,18.715,19.309s18.27,2.194,18.27-17.992C1327.978,460.248,1323.076,461.564,1312.381,458.931Z"
                                            transform="translate(-1290.928 -458.439)" data-v-39e05124=""></path>
                                        <path id="路径_35" data-name="17-2" class="cls-3"
                                            d="M1303.1,468s1.55,6.141,4.651,6.141l.775-1.535h6.2l3.1-.768-4.651,2.3-1.55,2.3-2.326-.768-.775,3.07,5.426,5.373-2.325.768v-.768l-3.1-2.3-.775,3.838-.775,2.3-.775-5.373H1300s6.977-1.535,6.977-3.838l.775-3.838h-2.325l-2.325-2.3Z"
                                            transform="translate(-1290.611 -458.104)" data-v-39e05124=""></path>
                                    </g>
                                    <g id="_18detailSvg" data-name="18" transform="translate(23.26 233.271)"
                                        data-v-39e05124="">
                                        <path id="路径_31-2" data-name="18-1" class="cls-4"
                                            d="M1553.7,537.749c-13.3,1.987-17.277-4.068-21.829-10.435-4.205-5.883-6.588-12.735-4.764-20.37,2.544-10.648,22.666-9.3,30.391-7.95,5.7.994,7.132,10.987,8.548,19.874C1567.949,530.793,1564.34,536.159,1553.7,537.749Z"
                                            transform="translate(-1526.491 -498.09)" data-v-39e05124=""></path>
                                        <path id="路径_50-2" data-name="18-2" class="cls-3"
                                            d="M1551.171,508.2v4.39l6.586,1.1-4.391,4.39-1.1,3.293,3.293,2.2,6.586,1.1-5.488,2.2-2.2,4.39-1.1-6.586h-3.293l-6.586,3.293v2.2L1538,525.757l4.39,1.1,7.683-4.391v-5.488l-7.683,1.1-3.293,3.293v-3.293l-1.1-4.39,3.293,3.293h8.781l-1.1-7.683-2.2-1.1,4.391-2.2Z"
                                            transform="translate(-1531.178 -499.233)" data-v-39e05124=""></path>
                                    </g>
                                    <path id="路径_551" data-name="路径 551" class="cls-3"
                                        d="M1339.636,381.586l-.927,1.1L1335,385.976l6.491-2.2,3.709,4.391v7.683l1.854-6.586,6.491-3.293-1.854-1.1-1.854,1.1h-3.709l-3.709-4.39L1339.636,375Z"
                                        transform="translate(-1074.71 -283.304)" data-v-39e05124=""></path>
                                </g><text id="_11-2detailSvg" data-name="11" class="cls-5"
                                    transform="translate(144.887 12)" data-v-39e05124="">
                                    <tspan x="0" y="0" data-v-39e05124="">11</tspan>
                                </text><text id="_21-2detailSvg" data-name="21" class="cls-5"
                                    transform="translate(198.671 12)" data-v-39e05124="">
                                    <tspan x="0" y="0" data-v-39e05124="">21</tspan>
                                </text><text id="_22-2detailSvg" data-name="22" class="cls-5"
                                    transform="translate(241.478 29.562)" data-v-39e05124="">
                                    <tspan x="0" y="0" data-v-39e05124="">22</tspan>
                                </text><text id="_12-2detailSvg" data-name="12" class="cls-5"
                                    transform="translate(100.982 29.562)" data-v-39e05124="">
                                    <tspan x="0" y="0" data-v-39e05124="">12</tspan>
                                </text><text id="_13-2detailSvg" data-name="13" class="cls-5"
                                    transform="translate(70.639 60.296)" data-v-39e05124="">
                                    <tspan x="0" y="0" data-v-39e05124="">13</tspan>
                                </text><text id="_14-2detailSvg" data-name="14" class="cls-5"
                                    transform="translate(47.198 89.932)" data-v-39e05124="">
                                    <tspan x="0" y="0" data-v-39e05124="">14</tspan>
                                </text><text id="_15-2detailSvg" data-name="15" class="cls-5"
                                    transform="translate(23.05 130.544)" data-v-39e05124="">
                                    <tspan x="0" y="0" data-v-39e05124="">15</tspan>
                                </text><text id="_16-2detailSvg" data-name="16" class="cls-5"
                                    transform="translate(4.391 170.058)" data-v-39e05124="">
                                    <tspan x="0" y="0" data-v-39e05124="">16</tspan>
                                </text><text id="_17-2detailSvg" data-name="17" class="cls-5"
                                    transform="translate(0 218.354)" data-v-39e05124="">
                                    <tspan x="0" y="0" data-v-39e05124="">17</tspan>
                                </text><text id="_18-2detailSvg" data-name="18" class="cls-5"
                                    transform="translate(5.488 266.65)" data-v-39e05124="">
                                    <tspan x="0" y="0" data-v-39e05124="">18</tspan>
                                </text><text id="_23-2detailSvg" data-name="23" class="cls-5"
                                    transform="translate(276.602 55.905)" data-v-39e05124="">
                                    <tspan x="0" y="0" data-v-39e05124="">23</tspan>
                                </text><text id="_24-2detailSvg" data-name="24" class="cls-5"
                                    transform="translate(304.043 91.029)" data-v-39e05124="">
                                    <tspan x="0" y="0" data-v-39e05124="">24</tspan>
                                </text><text id="_25-2detailSvg" data-name="25" class="cls-5"
                                    transform="translate(329.288 126.153)" data-v-39e05124="">
                                    <tspan x="0" y="0" data-v-39e05124="">25</tspan>
                                </text><text id="_26-2detailSvg" data-name="26" class="cls-5"
                                    transform="translate(339.167 170.058)" data-v-39e05124="">
                                    <tspan x="0" y="0" data-v-39e05124="">26</tspan>
                                </text><text id="_27-2detailSvg" data-name="27" class="cls-5"
                                    transform="translate(347.948 213.963)" data-v-39e05124="">
                                    <tspan x="0" y="0" data-v-39e05124="">27</tspan>
                                </text><text id="_28-2detailSvg" data-name="28" class="cls-5"
                                    transform="translate(346.85 257.869)" data-v-39e05124="">
                                    <tspan x="0" y="0" data-v-39e05124="">28</tspan>
                                </text>
                            </g>
                        </g>
                        <g id="组_611-2" data-name="组 611" transform="translate(12.904 305.409)" data-v-39e05124="">
                            <path id="下颌牙龈" class="cls-2"
                                d="M178.906,65.109c20.845,8.778,67.5,41.451,79.836,121.623,4.39,28.538-6.586,76.834,18.66,87.81s62.609-4.19,59.272-84.517C333.381,110.756,256.547-4.495,168.737.135,80.8,4.772,32.631,78.925,9.581,148.315c-23.775,71.572-.136,128.538,36.222,129.52,40.612,1.1,31.006-54.857,32.929-77.932C80.823,174.8,88.894,94.483,158.024,65.54,161.443,64.108,172.664,62.482,178.906,65.109Z"
                                transform="translate(336.883 277.851) rotate(180)" data-v-39e05124=""></path>
                            <path id="_33detailSvg" data-name="33" class="cls-6"
                                d="M20.968,29.963c8.466-2.116,11.928-18.034,6.349-25.4C21.945-2.525,2.939-.126.863,3.508c-4.233,7.407,8.26,24.537,12.6,26.025A12.629,12.629,0,0,0,20.968,29.963Z"
                                transform="translate(248.926 241.003) rotate(180)" data-v-39e05124=""></path>
                            <path id="_32detailSvg" data-name="32" class="cls-6"
                                d="M15.41,27.9s6.746,3.855,10.174-2.161a7.125,7.125,0,0,0,.6-2.08c.251-3.176-.083-12.9-.083-18.21A6.914,6.914,0,0,0,21.825.1C15.41-.965,1.512,6.518.443,9.726s0,5.346,1.069,6.415S13.272,26.831,15.41,27.9Z"
                                transform="translate(222.78 254.809) rotate(180)" data-v-39e05124=""></path>
                            <path id="_31detailSvg" data-name="31" class="cls-6"
                                d="M8.793,23.757s4.679,6.551,9.468-.451c.116-.169.49-1.016.49-1.016l4.765-16.2S25.479,1.182,18.608.2,2.9,2.163,2.9,2.163-2,4.126.941,10.016,8.793,23.757,8.793,23.757Z"
                                transform="translate(193.587 259.478) rotate(180)" data-v-39e05124=""></path>
                            <path id="_41detailSvg" data-name="41" class="cls-6"
                                d="M4.255,24.553s5.17,7.238,10.34,1.034l7.5-14.222s1.017-1.522,1.269-1.916c1.572-2.473-1.644-6.149-4.632-7.643C15.02-.049,4.255-1.3.923,2.305c-.395.427-1.233,1.862-.8,4.67C1.079,13.25,3.221,22.485,4.255,24.553Z"
                                transform="translate(167.723 259.478) rotate(180)" data-v-39e05124=""></path>
                            <path id="_42detailSvg" data-name="42" class="cls-6"
                                d="M1.011,21.233A9.394,9.394,0,0,0,4.044,27.3c3.033,3.033,7.078,0,7.078,0L23.255,16.178s6.067-6.067,1.011-9.1a82.49,82.49,0,0,0-9.1-5.056A24.479,24.479,0,0,0,6.067,0S0,0,0,6.067,1.011,21.233,1.011,21.233Z"
                                transform="translate(141.1 254.339) rotate(180)" data-v-39e05124=""></path>
                            <g id="_38detailSvg" data-name="38" transform="translate(316.721 58.638) rotate(180)"
                                data-v-39e05124="">
                                <path id="路径_144" data-name="38-1" class="cls-4"
                                    d="M18.064,38.391c4.014,0,19.067,4.922,20.071-8.859V9.844S38.135,0,29.1,0A128.658,128.658,0,0,0,13.046.984S1,1.969,0,12.8v15.75S0,43.313,14.05,39.375A10.536,10.536,0,0,1,18.064,38.391Z"
                                    transform="translate(0)" data-v-39e05124=""></path>
                                <path id="路径_169" data-name="38-2" class="cls-3"
                                    d="M1.1,19.208s4.391-2.2,6.586-1.1l1.1.549,1.1,5.488h-1.1l4.391-4.391,6.586,4.391-5.488-6.586V12.074l2.2-2.2s6.586-2.2,6.586-5.488a9.216,9.216,0,0,1-8.781,3.293l-1.1-1.646-4.391-1.1L5.488,0h-2.2V1.646l3.293,2.2,2.2,2.744V9.33l3.293-.549v4.391L7.683,17.013,0,17.562Z"
                                    transform="translate(6.655 7.234)" data-v-39e05124=""></path>
                            </g>
                            <g id="_37detailSvg" data-name="37" transform="translate(315.348 101.183) rotate(180)"
                                data-v-39e05124="">
                                <path id="路径_145" data-name="37-1" class="cls-4"
                                    d="M.821,19.293C1.916,11.6-.274-.91,19.436.052c10.651.519,15.683,4.573,17.05,9.681,1.164,4.343-.625,9.715-.625,11.484,0,3.848,2.19,12.506-2.19,15.392s-24.434,6.011-29.565,0C-2.464,28.913.821,19.293.821,19.293Z"
                                    transform="translate(0 0)" data-v-39e05124=""></path>
                                <path id="路径_160" data-name="37-2" class="cls-3"
                                    d="M0,13.172l2.185,4.391,8.739-1.1,6.554,8.781L12.017,14.269v-2.2l3.277-4.391h3.277v-2.2l-5.462,1.1H10.924L7.647,3.293H5.462L1.092,0,9.832,8.781v4.391l-2.185,1.1-2.185,1.1Z"
                                    transform="translate(9.055 9.181)" data-v-39e05124=""></path>
                            </g>
                            <g id="_36detailSvg" data-name="36" transform="translate(309.709 143.805) rotate(180)"
                                data-v-39e05124="">
                                <path id="路径_146" data-name="36-1" class="cls-4"
                                    d="M37.014,28.521C40.366,21.817,41.934,4.9,26.189.966S7.491,5.887,6.507,13.759c0,0-8.857,7.873-5.9,16.729s18.7,10.825,24.6,8.857S35.046,32.457,37.014,28.521Z"
                                    transform="translate(0 0)" data-v-39e05124=""></path>
                                <path id="路径_161" data-name="36-2" class="cls-3"
                                    d="M9.879,21.953l3.293,2.2-1.1-6.586H18.66l-4.391-4.391V8.781l3.293-2.2,5.488-2.2-5.488,1.1V0l-2.2,6.586h-2.2L4.391,1.1l6.586,7.683,1.1,4.391h-2.2L0,16.464l9.879-1.1,2.2-1.1L10.2,17Z"
                                    transform="translate(10.001 9.764)" data-v-39e05124=""></path>
                            </g>
                            <g id="_35detailSvg" data-name="35" transform="translate(293.67 185.023) rotate(180)"
                                data-v-39e05124="">
                                <path id="路径_147" data-name="35-1" class="cls-4"
                                    d="M33.2,31.428C39.24,22.683,42.259,10.05,32.2,3.247c-5.45-3.685-13.025-5.288-20.123.972C6.069,9.514,0,22.116,0,26.57c0,9.718,15.178,15.764,21.129,14.576S31.956,33.237,33.2,31.428Z"
                                    transform="translate(0 0)" data-v-39e05124=""></path>
                                <path id="路径_162" data-name="35-2" class="cls-3"
                                    d="M0,15.367H4.391l2.2-1.1,5.488,3.293L7.683,13.172l2.2-5.488,1.1-1.1,6.586-2.2H9.879L6.586,0l2.2,6.586-2.2,5.488Z"
                                    transform="translate(13.72 14.36)" data-v-39e05124=""></path>
                            </g>
                            <g id="_34detailSvg" data-name="34" transform="translate(267.861 216.307) rotate(180)"
                                data-v-39e05124="">
                                <path id="路径_148" data-name="34-1" class="cls-4"
                                    d="M27.062,24.716s11.456-11.456,0-21c0,0-13.366-10.5-22.913,3.819,0,0-10.5,17.185,1.909,22.913C6.059,30.444,18.47,40.946,27.062,24.716Z"
                                    transform="translate(0 0)" data-v-39e05124="">
                                </path>
                                <path id="路径_163" data-name="34-2" class="cls-3"
                                    d="M5.525,18.66l1.842-7.683,9.209-4.391-7.367,2.2L10.13,0,6.446,8.781,0,14.269l1.842,1.1,3.684-4.391Z"
                                    transform="translate(7.795 6.078)" data-v-39e05124=""></path>
                            </g>
                            <g id="_44detailSvg" data-name="44" transform="translate(99.102 217.558) rotate(180)"
                                data-v-39e05124="">
                                <path id="路径_155" data-name="44-1" class="cls-4"
                                    d="M5.274,24.538S-6.41,12.883,5,3.171c0,0,13.316-9.712,22.828,4.856,0,0,10.733,17.482-1.632,23.309C26.2,31.336,13.564,40.077,5.274,24.538Z"
                                    transform="translate(0 0)" data-v-39e05124=""></path>
                                <path id="路径_168" data-name="44-2" class="cls-3"
                                    d="M12.083,18.66l-2.014-7.683L0,6.586l8.055,2.2L7.048,0l4.028,8.781,7.048,5.488-2.014,1.1-4.028-4.391Z"
                                    transform="translate(6.446 5.753)" data-v-39e05124=""></path>
                            </g>
                            <g id="_45detailSvg" data-name="45" transform="translate(81.367 185.023) rotate(180)"
                                data-v-39e05124="">
                                <path id="路径_156" data-name="45-1" class="cls-4"
                                    d="M5.557,31.428C-.48,22.683-3.5,10.05,6.563,3.247c5.451-3.685,13.025-5.288,20.123.972,6,5.3,12.074,17.9,12.074,22.351,0,9.718-15.178,15.764-21.129,14.576S6.8,33.237,5.557,31.428Z"
                                    transform="translate(0 0)" data-v-39e05124=""></path>
                                <path id="路径_167" data-name="45-2" class="cls-3"
                                    d="M17.562,15.367H13.172l-2.2-1.1L5.488,17.562l4.391-4.391-2.2-5.488-1.1-1.1L0,4.391H7.683L10.976,0l-2.2,6.586,2.2,5.488Z"
                                    transform="translate(10.354 12.399)" data-v-39e05124=""></path>
                            </g>
                            <g id="_46detailSvg" data-name="46" transform="translate(68.231 143.805) rotate(180)"
                                data-v-39e05124="">
                                <path id="路径_157" data-name="46-1" class="cls-4"
                                    d="M2.246,28.521C-1.172,21.817-2.772,4.9,13.285.966s19.067,4.92,20.071,12.793c0,0,9.032,7.873,6.021,16.729S20.31,41.314,14.288,39.345,4.253,32.457,2.246,28.521Z"
                                    transform="translate(0 0)" data-v-39e05124=""></path>
                                <path id="路径_166" data-name="46-2" class="cls-3"
                                    d="M13.172,21.953l-3.293,2.2,1.1-6.586H4.391l4.391-4.391V8.781l-3.293-2.2L0,4.391l5.488,1.1V0l2.2,6.586h2.2L18.66,1.1,12.074,8.781l-1.1,4.391h2.2l9.879,3.293-9.879-1.1-2.2-1.1L12.855,17Z"
                                    transform="translate(7.739 9.764)" data-v-39e05124=""></path>
                            </g>
                            <g id="_47detailSvg" data-name="47" transform="translate(57.406 101.183) rotate(180)"
                                data-v-39e05124="">
                                <path id="路径_158" data-name="47-1" class="cls-4"
                                    d="M34.572,19.293c-1.05-7.7,1.05-20.2-17.848-19.24C6.512.572,1.688,4.626.377,9.733c-1.115,4.343.6,9.715.6,11.484,0,3.848-2.1,12.506,2.1,15.392s23.426,6.011,28.346,0C37.721,28.913,34.572,19.293,34.572,19.293Z"
                                    transform="translate(0 0)" data-v-39e05124=""></path>
                                <path id="路径_165" data-name="47-2" class="cls-3"
                                    d="M18.66,13.172l-2.2,4.391H8.781L1.1,25.245,6.586,14.269v-2.2L3.293,7.683H0v-2.2l5.488,1.1h2.2l3.293-3.293h2.2L17.562,0,8.781,8.781v4.391l2.2,1.1,2.2,1.1Z"
                                    transform="translate(8.76 9.181)" data-v-39e05124=""></path>
                            </g>
                            <g id="_48detailSvg" data-name="48" transform="translate(59.876 58.638) rotate(180)"
                                data-v-39e05124="">
                                <path id="路径_159" data-name="48-1" class="cls-4"
                                    d="M20.071,38.391C16.057,38.391,1,43.313,0,29.531V9.844S0,0,9.032,0A128.658,128.658,0,0,1,25.089.984S37.131,1.969,38.135,12.8v15.75s0,14.766-14.05,10.828A10.536,10.536,0,0,0,20.071,38.391Z"
                                    transform="translate(0 0)" data-v-39e05124=""></path>
                                <path id="路径_164" data-name="48-2" class="cls-3"
                                    d="M18.548,19.208s-3.71-2.2-5.564-1.1l-.927.549-.927,5.488h.927L8.346,18.66,2.782,24.148l4.637-6.586V12.074l-1.855-2.2S0,7.683,0,4.391c0,0,2.782,4.391,7.419,3.293l.927-1.646,3.71-1.1L14.838,0h1.855V1.646l-2.782,2.2L12.056,6.586V9.33L9.274,8.781v4.391l3.71,3.842,6.492.549Z"
                                    transform="translate(9.33 7.234)" data-v-39e05124=""></path>
                            </g>
                            <g id="组_43571" data-name="组 43571" data-v-39e05124="">
                                <path id="_43detailSvg" data-name="43" class="cls-6"
                                    d="M2.348,7.017s-5.766,7.1.774,18,16.351,6.54,21.8-4.36,6.54-14.17,3.27-17.441S5.935-3.356,2.348,7.017Z"
                                    transform="translate(118.691 240.758) rotate(180)" data-v-39e05124=""></path>
                            </g>
                        </g>
                        <g id="组_548" data-name="组 548" transform="translate(4.054 341.522)" data-v-39e05124=""><text
                                id="_41-2detailSvg" data-name="41" class="cls-7" transform="translate(151.412 251.006)"
                                data-v-39e05124="">
                                <tspan x="0" y="0" data-v-39e05124="">41</tspan>
                            </text><text id="_31-2detailSvg" data-name="31" class="cls-7"
                                transform="translate(187.701 249.755)" data-v-39e05124="">
                                <tspan x="0" y="0" data-v-39e05124="">31</tspan>
                            </text><text id="_32-2detailSvg" data-name="32" class="cls-7"
                                transform="translate(223.99 239.744)" data-v-39e05124="">
                                <tspan x="0" y="0" data-v-39e05124="">32</tspan>
                            </text><text id="_42-2detailSvg" data-name="42" class="cls-7"
                                transform="translate(115.123 239.744)" data-v-39e05124="">
                                <tspan x="0" y="0" data-v-39e05124="">42</tspan>
                            </text><text id="_43-2detailSvg" data-name="43" class="cls-7"
                                transform="translate(90.096 223.476)" data-v-39e05124="">
                                <tspan x="0" y="0" data-v-39e05124="">43</tspan>
                            </text><text id="_44-2detailSvg" data-name="44" class="cls-7"
                                transform="translate(55.059 194.696)" data-v-39e05124="">
                                <tspan x="0" y="0" data-v-39e05124="">44</tspan>
                            </text><text id="_45-2detailSvg" data-name="45" class="cls-7"
                                transform="translate(30.032 162.161)" data-v-39e05124="">
                                <tspan x="0" y="0" data-v-39e05124="">45</tspan>
                            </text><text id="_46-2detailSvg" data-name="46" class="cls-7"
                                transform="translate(12.513 117.113)" data-v-39e05124="">
                                <tspan x="0" y="0" data-v-39e05124="">46</tspan>
                            </text><text id="_47-2detailSvg" data-name="47" class="cls-7"
                                transform="translate(0 64.556)" data-v-39e05124="">
                                <tspan x="0" y="0" data-v-39e05124="">47</tspan>
                            </text><text id="_48-2detailSvg" data-name="48" class="cls-7"
                                transform="translate(1.251 13.251)" data-v-39e05124="">
                                <tspan x="0" y="0" data-v-39e05124="">48</tspan>
                            </text><text id="_33-2detailSvg" data-name="33" class="cls-7"
                                transform="translate(254.022 219.722)" data-v-39e05124="">
                                <tspan x="0" y="0" data-v-39e05124="">33</tspan>
                            </text><text id="_34-2detailSvg" data-name="34" class="cls-7"
                                transform="translate(285.306 183.434)" data-v-39e05124="">
                                <tspan x="0" y="0" data-v-39e05124="">34</tspan>
                            </text><text id="_35-2detailSvg" data-name="35" class="cls-7"
                                transform="translate(311.584 148.396)" data-v-39e05124="">
                                <tspan x="0" y="0" data-v-39e05124="">35</tspan>
                            </text><text id="_36-2detailSvg" data-name="36" class="cls-7"
                                transform="translate(327.851 108.353)" data-v-39e05124="">
                                <tspan x="0" y="0" data-v-39e05124="">36</tspan>
                            </text><text id="_37-2detailSvg" data-name="37" class="cls-7"
                                transform="translate(337.862 55.797)" data-v-39e05124="">
                                <tspan x="0" y="0" data-v-39e05124="">37</tspan>
                            </text><text id="_38-2detailSvg" data-name="38" class="cls-7"
                                transform="translate(337.862 12)" data-v-39e05124="">
                                <tspan x="0" y="0" data-v-39e05124="">38</tspan>
                            </text></g><text id="上颌" class="cls-8" transform="translate(180.728 197.105)"
                            data-v-39e05124="">
                            <tspan x="0" y="0" text-anchor="middle" data-v-39e05124="">Upper jaw</tspan>
                        </text><text id="下颌" class="cls-8" transform="translate(183.231 411.084)" data-v-39e05124="">
                            <tspan x="0" y="0" text-anchor="middle" data-v-39e05124="">Lower jaw</tspan>
                        </text>
                    </g>
                </g>
                <g id="47_48detailSvg" data-name="椭圆 35" class="cls-9" transform="translate(725 693.68)"
                    data-v-39e05124="">
                    <circle class="cls-10" cx="7" cy="7" r="7" data-v-39e05124=""></circle>
                    <circle class="cls-11" cx="7" cy="7" r="6.5" data-v-39e05124=""></circle>
                </g>
                <g id="组_43573" data-name="组 43573" data-v-39e05124="">
                    <g id="46_47detailSvg" data-name="椭圆 36" class="cls-9" transform="translate(730 740.68)"
                        data-v-39e05124="">
                        <circle class="cls-10" cx="7" cy="7" r="7" data-v-39e05124=""></circle>
                        <circle class="cls-11" cx="7" cy="7" r="6.5" data-v-39e05124=""></circle>
                    </g>
                </g>
                <g id="45_46detailSvg" data-name="椭圆 38" class="cls-9" transform="translate(744 784.68)"
                    data-v-39e05124="">
                    <circle class="cls-10" cx="7" cy="7" r="7" data-v-39e05124=""></circle>
                    <circle class="cls-11" cx="7" cy="7" r="6.5" data-v-39e05124=""></circle>
                </g>
                <g id="44_45detailSvg" data-name="椭圆 39" class="cls-9" transform="translate(765 829.68)"
                    data-v-39e05124="">
                    <circle class="cls-10" cx="7" cy="7" r="7" data-v-39e05124=""></circle>
                    <circle class="cls-11" cx="7" cy="7" r="6.5" data-v-39e05124=""></circle>
                </g>
                <g id="43_44detailSvg" data-name="椭圆 40" class="cls-9" transform="translate(789 861.68)"
                    data-v-39e05124="">
                    <circle class="cls-10" cx="7" cy="7" r="7" data-v-39e05124=""></circle>
                    <circle class="cls-11" cx="7" cy="7" r="6.5" data-v-39e05124=""></circle>
                </g>
                <g id="42_43detailSvg" data-name="椭圆 41" class="cls-9" transform="translate(817 884.68)"
                    data-v-39e05124="">
                    <circle class="cls-10" cx="7" cy="7" r="7" data-v-39e05124=""></circle>
                    <circle class="cls-11" cx="7" cy="7" r="6.5" data-v-39e05124=""></circle>
                </g>
                <g id="41_42detailSvg" data-name="椭圆 42" class="cls-9" transform="translate(850 897.68)"
                    data-v-39e05124="">
                    <circle class="cls-10" cx="7" cy="7" r="7" data-v-39e05124=""></circle>
                    <circle class="cls-11" cx="7" cy="7" r="6.5" data-v-39e05124=""></circle>
                </g>
                <g id="31_41detailSvg" data-name="椭圆 43" class="cls-9" transform="translate(879.479 902)"
                    data-v-39e05124="">
                    <circle class="cls-10" cx="7" cy="7" r="7" data-v-39e05124=""></circle>
                    <circle class="cls-11" cx="7" cy="7" r="6.5" data-v-39e05124=""></circle>
                </g>
                <g id="32_31detailSvg" data-name="椭圆 44" class="cls-9" transform="translate(908.958 897.68)"
                    data-v-39e05124="">
                    <circle class="cls-10" cx="7" cy="7" r="7" data-v-39e05124=""></circle>
                    <circle class="cls-11" cx="7" cy="7" r="6.5" data-v-39e05124=""></circle>
                </g>
                <g id="33_32detailSvg" data-name="椭圆 45" class="cls-9" transform="translate(940.958 884.68)"
                    data-v-39e05124="">
                    <circle class="cls-10" cx="7" cy="7" r="7" data-v-39e05124=""></circle>
                    <circle class="cls-11" cx="7" cy="7" r="6.5" data-v-39e05124=""></circle>
                </g>
                <g id="34_33detailSvg" data-name="椭圆 46" class="cls-9" transform="translate(969.958 861.68)"
                    data-v-39e05124="">
                    <circle class="cls-10" cx="7" cy="7" r="7" data-v-39e05124=""></circle>
                    <circle class="cls-11" cx="7" cy="7" r="6.5" data-v-39e05124=""></circle>
                </g>
                <g id="35_34detailSvg" data-name="椭圆 47" class="cls-9" transform="translate(991.958 829.68)"
                    data-v-39e05124="">
                    <circle class="cls-10" cx="7" cy="7" r="7" data-v-39e05124=""></circle>
                    <circle class="cls-11" cx="7" cy="7" r="6.5" data-v-39e05124=""></circle>
                </g>
                <g id="36_35detailSvg" data-name="椭圆 48" class="cls-9" transform="translate(1015.958 784.68)"
                    data-v-39e05124="">
                    <circle class="cls-10" cx="7" cy="7" r="7" data-v-39e05124=""></circle>
                    <circle class="cls-11" cx="7" cy="7" r="6.5" data-v-39e05124=""></circle>
                </g>
                <g id="37_36detailSvg" data-name="椭圆 49" class="cls-9" transform="translate(1030.958 740.68)"
                    data-v-39e05124="">
                    <circle class="cls-10" cx="7" cy="7" r="7" data-v-39e05124=""></circle>
                    <circle class="cls-11" cx="7" cy="7" r="6.5" data-v-39e05124=""></circle>
                </g>
                <g id="38_37detailSvg" data-name="椭圆 50" class="cls-9" transform="translate(1034.958 693.68)"
                    data-v-39e05124="">
                    <circle class="cls-10" cx="7" cy="7" r="7" data-v-39e05124=""></circle>
                    <circle class="cls-11" cx="7" cy="7" r="6.5" data-v-39e05124=""></circle>
                </g>
                <g id="27_28detailSvg" data-name="椭圆 51" class="cls-9" transform="translate(1037.958 566.68)"
                    data-v-39e05124="">
                    <circle class="cls-10" cx="7" cy="7" r="7" data-v-39e05124=""></circle>
                    <circle class="cls-11" cx="7" cy="7" r="6.5" data-v-39e05124=""></circle>
                </g>
                <g id="26_27detailSvg" data-name="椭圆 52" class="cls-9" transform="translate(1034.958 517.68)"
                    data-v-39e05124="">
                    <circle class="cls-10" cx="7" cy="7" r="7" data-v-39e05124=""></circle>
                    <circle class="cls-11" cx="7" cy="7" r="6.5" data-v-39e05124=""></circle>
                </g>
                <g id="25_26detailSvg" data-name="椭圆 53" class="cls-9" transform="translate(1025.958 474.68)"
                    data-v-39e05124="">
                    <circle class="cls-10" cx="7" cy="7" r="7" data-v-39e05124=""></circle>
                    <circle class="cls-11" cx="7" cy="7" r="6.5" data-v-39e05124=""></circle>
                </g>
                <g id="24_25detailSvg" data-name="椭圆 54" class="cls-9" transform="translate(1008.958 439.68)"
                    data-v-39e05124="">
                    <circle class="cls-10" cx="7" cy="7" r="7" data-v-39e05124=""></circle>
                    <circle class="cls-11" cx="7" cy="7" r="6.5" data-v-39e05124=""></circle>
                </g>
                <g id="23_24detailSvg" data-name="椭圆 55" class="cls-9" transform="translate(985.958 407.68)"
                    data-v-39e05124="">
                    <circle class="cls-10" cx="7" cy="7" r="7" data-v-39e05124=""></circle>
                    <circle class="cls-11" cx="7" cy="7" r="6.5" data-v-39e05124=""></circle>
                </g>
                <g id="22_23detailSvg" data-name="椭圆 56" class="cls-9" transform="translate(965.958 380.68)"
                    data-v-39e05124="">
                    <circle class="cls-10" cx="7" cy="7" r="7" data-v-39e05124=""></circle>
                    <circle class="cls-11" cx="7" cy="7" r="6.5" data-v-39e05124=""></circle>
                </g>
                <g id="21_22detailSvg" data-name="椭圆 57" class="cls-9" transform="translate(925.958 353.68)"
                    data-v-39e05124="">
                    <circle class="cls-10" cx="7" cy="7" r="7" data-v-39e05124=""></circle>
                    <circle class="cls-11" cx="7" cy="7" r="6.5" data-v-39e05124=""></circle>
                </g>
                <g id="11_21detailSvg" data-name="椭圆 58" class="cls-9" transform="translate(876.958 343)"
                    data-v-39e05124="">
                    <circle class="cls-10" cx="7" cy="7" r="7" data-v-39e05124=""></circle>
                    <circle class="cls-11" cx="7" cy="7" r="6.5" data-v-39e05124=""></circle>
                </g>
                <g id="12_11detailSvg" data-name="椭圆 59" class="cls-9" transform="translate(829.958 353.68)"
                    data-v-39e05124="">
                    <circle class="cls-10" cx="7" cy="7" r="7" data-v-39e05124=""></circle>
                    <circle class="cls-11" cx="7" cy="7" r="6.5" data-v-39e05124=""></circle>
                </g>
                <g id="13_12detailSvg" data-name="椭圆 60" class="cls-9" transform="translate(792.958 380.68)"
                    data-v-39e05124="">
                    <circle class="cls-10" cx="7" cy="7" r="7" data-v-39e05124=""></circle>
                    <circle class="cls-11" cx="7" cy="7" r="6.5" data-v-39e05124=""></circle>
                </g>
                <g id="14_13detailSvg" data-name="椭圆 61" class="cls-9" transform="translate(771.958 407.68)"
                    data-v-39e05124="">
                    <circle class="cls-10" cx="7" cy="7" r="7" data-v-39e05124=""></circle>
                    <circle class="cls-11" cx="7" cy="7" r="6.5" data-v-39e05124=""></circle>
                </g>
                <g id="15_14detailSvg" data-name="椭圆 62" class="cls-9" transform="translate(751.958 439.68)"
                    data-v-39e05124="">
                    <circle class="cls-10" cx="7" cy="7" r="7" data-v-39e05124=""></circle>
                    <circle class="cls-11" cx="7" cy="7" r="6.5" data-v-39e05124=""></circle>
                </g>
                <g id="16_15detailSvg" data-name="椭圆 63" class="cls-9" transform="translate(734.958 474.68)"
                    data-v-39e05124="">
                    <circle class="cls-10" cx="7" cy="7" r="7" data-v-39e05124=""></circle>
                    <circle class="cls-11" cx="7" cy="7" r="6.5" data-v-39e05124=""></circle>
                </g>
                <g id="17_16detailSvg" data-name="椭圆 64" class="cls-9" transform="translate(723.958 517.68)"
                    data-v-39e05124="">
                    <circle class="cls-10" cx="7" cy="7" r="7" data-v-39e05124=""></circle>
                    <circle class="cls-11" cx="7" cy="7" r="6.5" data-v-39e05124=""></circle>
                </g>
                <g id="18_17detailSvg" data-name="椭圆 65" class="cls-9" transform="translate(720.958 566.68)"
                    data-v-39e05124="">
                    <circle class="cls-10" cx="7" cy="7" r="7" data-v-39e05124=""></circle>
                    <circle class="cls-11" cx="7" cy="7" r="6.5" data-v-39e05124=""></circle>
                </g>
            </g>
        </svg>
    </div>
</template>

<style>

.dashboard-body {
    background-color: white;
}

div {
    text-align: left;
}

.title-div {
    margin-top: 20px;
    font-family: Arial, sans-serif;
    font-size: 20px;
    font-weight: bold;
    text-align: left;
    color: black;
}

/* ul {
    list-style-type: none;
    padding: 0px; 
} */

li {
    line-height: 2;
}

.green_class {
    color: green;
}

.v-for-row {
    display: flex;
    flex-direction: row;
}

.v-for-row-item {
    font-size: 32px;
    font-weight: bold;
    margin-right: 10px;
    background-color: pink;
}

.v-for-buttons button {
    margin-right: 10px;
    margin-top: 10px;
}

#container {
    color: red;
}

.beRed {
    color: red;
}

.cls-1[data-v-39e05124],
.cls-11[data-v-39e05124] {
    fill: none
}

.cls-1[data-v-39e05124] {
    stroke: #999;
    stroke-dasharray: 3 3
}

.cls-2[data-v-39e05124] {
    fill: #fac8ce;
    display: none
}

.cls-3[data-v-39e05124] {
    fill: #cacaca
}

.cls-4[data-v-39e05124],
.cls-6[data-v-39e05124],
.cls-9[data-v-39e05124] {
    fill: #fff
}

.cls-4[data-v-39e05124] {
    stroke: #393730
}

.cls-4[data-v-39e05124],
.cls-6[data-v-39e05124] {
    stroke-miterlimit: 10
}

.cls-5[data-v-39e05124] {
    fill: #333;
    font-weight: 700
}

.cls-5[data-v-39e05124],
.cls-7[data-v-39e05124],
.cls-8[data-v-39e05124] {
    font-size: 14px;
    font-family: SourceHanSansCN-Normal, Source Han Sans CN
}

.cls-6[data-v-39e05124] {
    stroke: #000
}

.cls-7[data-v-39e05124] {
    fill: #242733;
    font-weight: 700
}

.cls-8[data-v-39e05124] {
    fill: #393730;
    letter-spacing: .024em
}

.cls-9[data-v-39e05124] {
    stroke: #ccc;
    display: none
}

.cls-10[data-v-39e05124] {
    stroke: none
}
</style>

<script>

export default {
    mounted() {
        console.log('Dashboard has been mounted!');

        this.setSVGPathColor("16", this.$colors.anatomicCrown);
        this.setSVGPathColor("33", this.$colors.veneer);
        this.setSVGPathColor("34", this.$colors.veneer);
        this.setSVGPathColor("42", this.$colors.missingTooth);
        this.setSVGPathColor("38", this.$colors.anatomicInlay);
        this.setSVGPathColor("25", this.$colors.anatomicPontic);
        this.setSVGPathColor("46", this.$colors.offsetInlay);
        this.showSVGCircle(34,33)

    },
    created() {
        console.log('Dashboard has been created!');
    },
    data() {
        return {
            title: "Dashboard",
        };
    },
    methods: {
        setSVGPathColor(dataName, color) {
            // Find the <path> element by its data-name attribute
            var pathName = dataName + "-1";
            var path = this.$el.querySelector(`path[data-name="${pathName}"]`);
            if (path == null) {
                console.log("can not find path: " + pathName);

                pathName = dataName;
                path = this.$el.querySelector(`path[data-name="${pathName}"]`);
            }

            if (path) {
                console.log("find path: " + pathName);
                // Apply the color to css style
                path.style.fill = color;
            } else {
                console.log("can not find path: " + pathName);
            }
        },

        showSVGCircle(fromPos, toPos) {
            // Find the <g> element by its data-name attribute
            var groupId = fromPos + "_" + toPos + "detailSvg";
            var group = this.$el.querySelector(`g[id="${groupId}`);
            if (group == null) {
                console.log("can not find group: " + groupId);

                groupId = toPos + "_" + fromPos + "detailSvg";
                group = this.$el.querySelector(`g[id="${groupId}`);
            }

            if (group) {
                console.log("find group: " + groupId);
                // Set the display style to 'block'
                group.style.display = 'block';
            } else {
                console.log("can not find group: " + groupId);
            }
        }
    }
};
</script>